document.addEventListener('DOMContentLoaded', () => {
    const now = new Date();
    const startDate = new Date(2023, 0, 3, 10); // February 3, 2023 10AM
    const finishDate = new Date(2023, 0, 4, 20); // February 4, 2023 20PM
    const isDateValid = now >= startDate && now <= finishDate;

    if (isDateValid && !sessionStorage.getItem('maintenance-popup')) {
        loadMaintenancePopup();
    }


   function loadMaintenancePopup() {
       const popup = document.createElement('div');
       popup.className = 'maintenance-popup';

       const container = document.createElement('div');
       container.className = 'maintenance-popup-container';

       const header = document.createElement('div');
       header.className = 'maintenance-popup-header';

       const close = document.createElement('button');
       close.type = 'button';
       close.className = 'maintenance-popup-close';
       close.addEventListener('click', () => popup.remove());

       const content = document.createElement('div');
       content.className = 'maintenance-popup-content';

       const h4 = document.createElement('h4');
       h4.textContent =  m.trans.get('Maintenance Popup Title');

       const p = document.createElement('p');
       p.innerHTML = m.trans.get('Maintenance Popup Content');

       const footer = document.createElement('div');
       footer.className = 'maintenance-popup-footer';

       const confirm = document.createElement('button');
       confirm.type = 'button';
       confirm.className = 'maintenance-popup-confirm mb-btn mb-btn_small mb-btn_primary';
       confirm.textContent = m.trans.get('Ok');
       confirm.addEventListener('click', () => popup.remove());

       header.append(close);
       content.append(h4, p);
       footer.append(confirm);
       container.append(header, content, footer);
       popup.append(container);
       document.body.append(popup);

       sessionStorage.setItem('maintenance-popup', 'loaded');
   }
});
